export default __webpack_public_path__ + "static/media/cif-mk.a006ad7c.svg";